import React, { Component } from "react";
import { connect } from 'react-redux';
import { fromJS } from "immutable";
import { bindActionCreators } from 'redux'
import { toast } from 'react-toastify';
import { ButtonGroup, Modal } from 'react-bootstrap'
import TextInputCustom from './CustomTextInput'
import TextInputField from "../../infra/components/formInput/CustomTextInput";
import ComboboxInput from '../../infra/components/formInput/ComboboxInput'
import Combocustom from '../PushInteractive/ComboboxInputCustom'

import ActionGetKeyGroup from '../../store/action/Keygroup/FetchAll'
import ActionAdd from '../../store/action/Reply/Add'
import ActionEdit from '../../store/action/Reply/Edit'

import { IsEdit, IsCreate, IsView } from '../../store/constants'


class Form extends Component {

  constructor(props) {
    super(props);
    this.state = {
      form: fromJS({
        'reply-id': '',
        'group-id': '',
        'type-category': '',
        'reply-type': '',
        'caption': '',
        'url': '',
      }),
      //===20211121===
      formbutton: fromJS({
        'type': '',
        'header-type': '',
        'url-header': '',
        'header': '',
        'body': '',
        'footer': '',
      }),
      types: fromJS([
        {
          'text': 'Text',
          'value': 'text'
        }, {
          'text': 'Media',
          'value': 'media'
        },
        {
          'text': 'Sticker',
          'value': 'sticker'

        }
      ]),
      typescategory: fromJS([
        {
          'text': 'Non Interactive',
          'value': 'non Interactive'
        }, {
          'text': 'Interactive',
          'value': 'interactive'
        },
      ]),
      typesbutton: fromJS([
        {
          'text': 'Button',
          'value': 'button'
        }, {
          'text': 'Button List',
          'value': 'list'
        },
      ]),
      listbutton: fromJS([
        {
          'text': 'Text',
          'value': 'text'
        }
      ]),
      buttons: fromJS([
        {
          'text': 'Text',
          'value': 'text'
        },
        {
          'text': 'Image',
          'value': 'image'
        },
        {
          'text': 'Video',
          'value': 'video'
        },
        {
          'text': 'Document',
          'value': 'document'
        },
      ]),
      hidebuttons: 'hide',
      hidelistbutton: 'hide',
      hideheader: 'hide',
      hidebuttonsmedia: 'hide',
      flagsubmit: false,
      hidetextheader: 'hide',
      hideinteractive: 'hide',
      hidenoninter: 'hide',
      countheader: 0,
      countbody: 0,
      countfooter: 0,
      formbuttoninteractive: fromJS([
        {
          'id-button': 'button1',
          'id': '',
          'title': '',
          'countchar': 0
        },
        {
          'id-button': 'button2',
          'id': '',
          'title': '',
          'countchar': 0
        },
        {
          'id-button': 'button3',
          'id': '',
          'title': '',
          'countchar': 0
        }
      ]),
      headerbuttonlist: fromJS({
        'menu-title': '',
        'count-char': 0
      }),
      formbuttonlist: fromJS({}),
      formbuttonrow: fromJS({}),
      countersection: 1,
      counterrow: 1,
      //===END========
      loadded: false,
      disabled: false,
      errors: fromJS({}),
      error: '',
      showUrlField: true,
      showCaptionField: ''
    };

    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleCancel = this.handleCancel.bind(this);
    this.renderGroupId = this.renderGroupId.bind(this);
    this.renderUrlField = this.renderUrlField.bind(this);
    this.addrow = this.addrow.bind(this)
    this.deleterow = this.deleterow.bind(this)
    this.deletesection = this.deletesection.bind(this)
    this.buildjson = this.buildjson.bind(this)
  }

  componentDidMount() {
    this.props.actionGetKeyGroup()
  }

  handleChange(field, value, label) {

    var formVal = this.state.form;
    formVal = formVal.set(field, value);
    if (field === 'reply-type') {
      if (value === 'media') {
        formVal = formVal.set('url', '')
        formVal = formVal.set('caption', '')
        this.setState({
          form: formVal,
          showUrlField: true,
          showCaptionField: ''
        })
      } else if (value === 'sticker') {
        formVal = formVal.set('url', '')
        formVal = formVal.set('caption', '')
        this.setState({
          showCaptionField: 'hide',
          showUrlField: true
        })
      } else {
        this.setState({
          form: formVal,
          showUrlField: false,
          showCaptionField: ''
        })
      }

    }
    if (field == 'type-category') {
      if(value == "" || value == null || value == undefined){
        this.setState({ hideinteractive: 'hide', hidenoninter: 'hide' })
      }else if (value == 'interactive'){ 
        this.setState({ hideinteractive: '', hidenoninter: 'hide' })
      }else this.setState({ hideinteractive: 'hide', hidenoninter: '' })
    }
    this.setState({
      form: formVal,
    })

  }

  async handleSubmit(dispatch) {
    const { form } = this.state;
    var formVal = form
    var isValid = true;

    if (formVal.get('type-category') == 'interactive') {
      var interactive = this.buildjson()
      if (interactive != true) {
        toast.error(interactive, toast.POSITION.TOP_RIGHT)
        return false
      } else {
        isValid = true
      }
    } else if (formVal.get('type-category') == 'non interactive') {

      var mandatoryField = fromJS(['reply-type', 'caption', 'url'])
      if (form.get('reply-type') === 'text') {
        mandatoryField = fromJS(['reply-type', 'caption'])
      } else if (form.get('reply-type') === 'sticker') {
        mandatoryField = fromJS(['reply-type', 'url'])
      }

      var newErrors = fromJS({});
      mandatoryField.map((field) => {
        if (form.get(field) === '') {
          isValid = false;
          newErrors = newErrors.set(field)
        }
      })

      this.setState({ errors: newErrors })
      if (!isValid) {
        toast.error("Mandatory Field Cannot Empty!", toast.POSITION.TOP_RIGHT)
      }
    } else {
      var mandatoryField = fromJS(['group-id', 'type-category'])
      var newErrors = fromJS({});
      mandatoryField.map((field) => {
        if (form.get(field) === '') {
          isValid = false;
          newErrors = newErrors.set(field)
        }
      })

      this.setState({ errors: newErrors })
      if (!isValid) {
        toast.error("Mandatory Field Cannot Empty!", toast.POSITION.TOP_RIGHT)
      }
    }

    //debugger
    if (isValid) {

      switch (this.props.actionType) {
        case IsCreate:
          await this.SubmitNewData();
          break;
        case IsEdit:
          await this.SubmitEditData();
          break;
        default:
        // code blocks
      }

    }
  }

  async SubmitNewData() {
    const form = this.state.form;
    const { formbutton, formbuttonlist, formbuttonrow, formbuttoninteractive } = this.state
    const { countersection, headerbuttonlist } = this.state
    var data = {}
    var interactive = {}
    var formValButton = formbutton
    var formVallist = formbuttonlist
    var formValinteractive = formbuttoninteractive
    var formrow = formbuttonrow
    var sections = []
    if (form.get('type-category') == 'interactive') {
      if (formValButton.get('type') == 'list') {
        for (let i = 1; i <= countersection; i++) {
          var datarow = []
          let jsonrow = {}
          let title = formVallist.get('section-' + i + '-title-' + i)
          for (let k = 1; k <= formVallist.get('section-' + i + '-count-row-' + i); k++) {
            if ((formrow.get('section-' + i + '-row-' + k + '-description')).length != 0
              && formrow.get('section-' + i + '-row-' + k + '-description') != null
              && formrow.get('section-' + i + '-row-' + k + '-description') != undefined) {
              jsonrow = {
                "id": formrow.get('section-' + i + '-row-' + k + '-id'),
                "title": formrow.get('section-' + i + '-row-' + k + '-title'),
                "description": formrow.get('section-' + i + '-row-' + k + '-description')
              }
            } else {
              jsonrow = {
                "id": formrow.get('section-' + i + '-row-' + k + '-id'),
                "title": formrow.get('section-' + i + '-row-' + k + '-title'),
              }
            }
            datarow.push(jsonrow)
          }
          let jsonsection = {
            "title": title,
            "rows": datarow
          }
          sections.push(jsonsection)
        }

        interactive = {
          "header": {
            "type": "text",
            "text": formValButton.get('header')
          },
          "body": {
            "text": formValButton.get('body')
          },
          "footer": {
            "text": formValButton.get('footer')
          },
          "action": {
            "button": headerbuttonlist.get('menu-title'),
            "sections": sections
          }
        }
      } else {
        var header = {}
        var headertype = formValButton.get('header-type')
        var buttons = []
        switch (headertype) {
          case 'text':
            header = {
              "type": "text",
              "text": formValButton.get('header')
            }
            break;
          case 'image':
            header = {
              "type": "image",
              "image": {
                "link": formValButton.get('url-header')
              }
            }
            break;
          case 'video':
            header = {
              "type": "video",
              "video": {
                "link": formValButton.get('url-header')
              }
            }
            break;
          case 'document':
            header = {
              "type": "document",
              "document": {
                "link": formValButton.get('url-header')
              }
            }
            break;
          default:
          // code blocks
        }
        for (let i = 0; i < formValinteractive.size; i++) {
          let type = {}
          let a = formValinteractive.get(i).get('title')
          //debugger
          if (formValinteractive.get(i).get('title') != ''
            && formValinteractive.get(i).get('title') != null
            && formValinteractive.get(i).get('title').length != 0) {
            type = {
              "type": "reply",
              "reply": {
                "id": formValinteractive.get(i).get('id'),
                "title": formValinteractive.get(i).get('title')
              }
            }
            buttons.push(type)
          }
        }
        interactive = {
          "header": header,
          "body": {
            "text": formValButton.get('body')
          },
          "footer": {
            "text": formValButton.get('footer')
          },
          "action": {
            "buttons": buttons
          }
        }
      }
      data =
      {
        'data':
        {
          'group-id': form.get('group-id'),
          'reply-type': formValButton.get('type'),
          'caption': '',
          'url': '',
          'interactive': interactive
        }

      }
    } else {
      data =
      {
        'data':
        {
          'group-id': form.get('group-id'),
          'reply-type': form.get('reply-type'),
          'caption': form.get('caption'),
          'url': form.get('url'),
        }

      }
    };
    var response = await this.props.actionAdd(data);
    if (response.ok) {
      toast.success("Save Success!", toast.POSITION.TOP_RIGHT);
      this.props.handleCancelForm(true);
    } else {
      toast.error("Save Failed!", toast.POSITION.TOP_RIGHT);
    }
  }

  async SubmitEditData() {
    const { form, formbutton, formbuttonlist, formbuttonrow, formbuttoninteractive } = this.state
    const { countersection, headerbuttonlist } = this.state
    var data = {}
    var interactive = {}
    var formValButton = formbutton
    var formVallist = formbuttonlist
    var formValinteractive = formbuttoninteractive
    var formrow = formbuttonrow
    var sections = []
    if (form.get('type-category') == 'interactive') {
      if (formValButton.get('type') == 'list') {
        for (let i = 1; i <= countersection; i++) {
          var datarow = []
          let jsonrow = {}
          let title = formVallist.get('section-' + i + '-title-' + i)
          for (let k = 1; k <= formVallist.get('section-' + i + '-count-row-' + i); k++) {
            if (formrow.get('section-' + i + '-row-' + k + '-description') != undefined
              && formrow.get('section-' + i + '-row-' + k + '-description') != null
              && formrow.get('section-' + i + '-row-' + k + '-description').length != 0) {
              jsonrow = {
                "id": formrow.get('section-' + i + '-row-' + k + '-id'),
                "title": formrow.get('section-' + i + '-row-' + k + '-title'),
                "description": formrow.get('section-' + i + '-row-' + k + '-description')
              }
            } else {
              jsonrow = {
                "id": formrow.get('section-' + i + '-row-' + k + '-id'),
                "title": formrow.get('section-' + i + '-row-' + k + '-title'),
              }
            }
            datarow.push(jsonrow)
          }
          let jsonsection = {
            "title": title,
            "rows": datarow
          }
          sections.push(jsonsection)
        }

        interactive = {
          "type": "list",
          "header": {
            "type": "text",
            "text": formValButton.get('header')
          },
          "body": {
            "text": formValButton.get('body')
          },
          "footer": {
            "text": formValButton.get('footer')
          },
          "action": {
            "button": headerbuttonlist.get('menu-title'),
            "sections": sections
          }
        }
      } else {
        var header = {}
        var headertype = formValButton.get('header-type')
        var buttons = []
        switch (headertype) {
          case 'text':
            header = {
              "type": "text",
              "text": formValButton.get('header')
            }
            break;
          case 'image':
            header = {
              "type": "image",
              "image": {
                "link": formValButton.get('url-header')
              }
            }
            break;
          case 'video':
            header = {
              "type": "video",
              "video": {
                "link": formValButton.get('url-header')
              }
            }
            break;
          case 'document':
            header = {
              "type": "document",
              "document": {
                "link": formValButton.get('url-header')
              }
            }
            break;
          default:
          // code blocks
        }
        for (let i = 0; i < formValinteractive.size; i++) {
          let type = {}
          let a = formValinteractive.get(i).get('title')
          //debugger
          if (formValinteractive.get(i).get('title') != ''
            && formValinteractive.get(i).get('title') != null
            && formValinteractive.get(i).get('title').length != 0) {
            type = {
              "type": "reply",
              "reply": {
                "id": formValinteractive.get(i).get('id'),
                "title": formValinteractive.get(i).get('title')
              }
            }
            buttons.push(type)
          }
        }
        interactive = {
          "type": "button",
          "header": header,
          "body": {
            "text": formValButton.get('body')
          },
          "footer": {
            "text": formValButton.get('footer')
          },
          "action": {
            "buttons": buttons
          }
        }
      }
      data =
      {
        'data':
        {
          'reply-id': form.get('reply-id'),
          'reply-type': formValButton.get('type'),
          'caption': '',
          'url': '',
          'interactive': interactive
        }

      }
      //debugger
    } else {
      if (form.get('reply-type') == 'sticker') {
        data =
        {
          'data': {
            'reply-id': form.get('reply-id'),
            'reply-type': form.get('reply-type'),
            'caption': '',
            'url': form.get('url'),
          }
        };
      } else if (form.get('reply-type') == 'text') {
        data =
        {
          'data': {
            'reply-id': form.get('reply-id'),
            'reply-type': form.get('reply-type'),
            'caption': form.get('caption'),
            'url': '',
          }
        };
      } else if (form.get('reply-type') == 'media') {
        data =
        {
          'data': {
            'reply-id': form.get('reply-id'),
            'reply-type': form.get('reply-type'),
            'caption': form.get('caption'),
            'url': form.get('url'),
          }
        };
      }
    }
    var response = await this.props.actionEdit(data);
    if (response.ok) {
      toast.success('Edit Success!', toast.POSITION.TOP_RIGHT);
      this.props.handleCancelForm(true);
    } else {
      toast.error('Edit Failed', toast.POSITION.TOP_RIGHT);
    }
  }

  buildjson() {
    const { formbutton, formbuttonlist, formbuttonrow, formbuttoninteractive } = this.state
    const { countersection, headerbuttonlist } = this.state
    var formValButton = formbutton
    var formVallist = formbuttonlist
    var formValinteractive = formbuttoninteractive
    var formrow = formbuttonrow
    var flagready = false
    //Validation Type Button 
    if (formValButton.get('type') != '' && formValButton.get('type') != null
      && formValButton.get('type').length != 0) {
      //validation header
      //debugger
      if (formValButton.get('header-type') != '' && formValButton.get('header') != null
        && formValButton.get('header-type').length != 0) {
        if (formValButton.get('header-type') != 'text') {
          if (formValButton.get('url-header') == '' || formValButton.get('url-header') == null
            || formValButton.get('url-header').length == 0) {
            return "Header url media is mandatory for type image,video,document"
          }
        } else {
          if (formValButton.get('header') == '' || formValButton.get('header') == null
            || formValButton.get('header').length == 0) {
            return "Header is mandatory for type text"
          }
        }
      } else {
        return "Header type is mandatory"
      }
      //validation body
      if (formValButton.get('body') == '' || formValButton.get('body') == null
        || formValButton.get('body').length == 0) return "body is mandatory"

      //validation footer
      if (formValButton.get('footer') == '' || formValButton.get('footer') == null
        || formValButton.get('footer').length == 0) return "Footer is mandatory"

      if (formValButton.get('type') == 'list') {
        //validation menu title of button list
        if (headerbuttonlist.get('menu-title') == ''
          || headerbuttonlist.get('menu-title') == null
          || headerbuttonlist.get('menu-title').length == 0) return "Title of list button is mandatory"


        //validation row and section
        for (let i = 1; i <= countersection; i++) {
          //valdiasi section
          //debugger
          if (formVallist.get('section-' + i + '-title-' + i) != ''
            && formVallist.get('section-' + i + '-title-' + i) != null
            && formVallist.get('section-' + i + '-title-' + i).length != 0) {
            for (let k = 1; k <= formVallist.get('section-' + i + '-count-row-' + i); k++) {
              //validasi row
              //debugger
              if (formrow.get('section-' + i + '-row-' + k + '-title') == ''
                || formrow.get('section-' + i + '-row-' + k + '-title') == null
                || formrow.get('section-' + i + '-row-' + k + '-title').length == 0) {
                return "Each title of submenu is mandatory"
              }
            }
          } else {
            return "Title of each section is mandatory"
          }
        }
        flagready = true
      } else if (formValButton.get('type') == 'button') {
        var flagempty = 0
        for (let i = 0; i < formValinteractive.size; i++) {
          if (formValinteractive.get(i).get('title') == ''
            || formValinteractive.get(i).get('title') == null
            || formValinteractive.get(i).get('title').length == 0) {
            flagempty += 1
          }
        }
        if (flagempty == 3) {
          return 'Button title is mandatory one title is minimum before submit'
        }
      }
      flagready = true
    } else {
      return "Button type is mandatory"
    }
    //debugger
    if (flagready) {
      return flagready
    }
  }

  handleCancel() {
    this.props.handleCancelForm(false);
  }

  handleChangeButton(field, value) {
    const { formbuttoninteractive } = this.state
    var formVal = formbuttoninteractive;
    var fieldinput = parseInt(field.substring(field.length - 1, field.length)) - 1

    if (value.length > 20) {
      formVal = formVal.set(fieldinput, formVal.get(fieldinput).set('title',
        formVal.get(fieldinput).get('title').substring(0, 20))).set(fieldinput, formVal.get(fieldinput).set('id',
          formVal.get(fieldinput).get('title').substring(0, 20)))
    } else {
      formVal = formVal.set(fieldinput, formVal.get(fieldinput).set('title', value).set('id', value))
    }
    formVal = formVal.set(fieldinput, formVal.get(fieldinput).set('countchar',
      formVal.get(fieldinput).get('title').length))
    console.log(formVal)
    this.setState({ formbuttoninteractive: formVal })
  }

  handleChangeModal(field, value, label) {
    const { flagsubmit } = this.state
    var formVal = this.state.formbutton
    formVal = formVal.set(field, value);
    if (field == "type") {
      if (value != "" && value != "null"
        && value != null && value != undefined) {
        this.setState({ hideheader: '' })
        if (value == "list") {
          this.setState({ hidelistbutton: '', hidebuttonsmedia: 'hide', hideheader: 'hide' }) 
          this.buildsection()
        }
        else this.setState({ hidelistbutton: 'hide' })
        if (value == "button") this.setState({ hidebuttons: '', hideheader: 'hide' })
        else this.setState({ hidebuttons: 'hide' })
        formVal = formVal.set('header-type', '').set('url-header', '').set('header', '')
      }
      else {
        if (!flagsubmit) {
          formVal = formVal.set('header-type', '').set('url-header', '').set('header', '')
        }
        this.setState({ hideheader: 'hide', hidelistbutton: 'hide', hidebuttons: 'hide', hidebuttonsmedia: 'hide', hidetextheader: 'hide' })
      }
    }
    if (field == "header-type") {
      if (value != "" && value != "null"
        && value != null && value != undefined) {
        if (value != "text") {
          this.setState({ hidebuttonsmedia: '', hidetextheader: 'hide' }) 
          formVal = formVal.set('header', '')
        }
        else this.setState({ hidebuttonsmedia: 'hide', hidetextheader: '' })
      } else {
        if (!flagsubmit) {
          formVal = formVal.set('url-header', '').set('header', '')
        }
        this.setState({ hidebuttonsmedia: 'hide', hidetextheader: 'hide' })
      }
    }

    if (field == 'header') {
      if (value.length > 60) {
        formVal = formVal.set('header', formVal.get('header').substring(0, 60))
      }
      this.setState({ countheader: formVal.get('header').length })
    }
    if (field == 'body') {
      if (value.length > 1024) {
        formVal = formVal.set('body', formVal.get('body').substring(0, 1024))
      }
      this.setState({ countbody: formVal.get('body').length })
    }
    if (field == 'footer') {
      if (value.length > 60) {
        formVal = formVal.set('footer', formVal.get('footer').substring(0, 60))
      }
      this.setState({ countfooter: formVal.get('footer').length })
    }
    this.setState({
      formbutton: formVal,
    })
  }

  handlechangeheader(field, value, label) {
    var formVal = this.state.headerbuttonlist
    formVal = formVal.set(field, value);
    if (field == 'menu-title') {
      if (value.length > 20) {
        formVal = formVal.set('menu-title', formVal.get('menu-title').substring(0, 20))
      }
      formVal = formVal.set('count-char', formVal.get('menu-title').length)
    }
    this.setState({
      headerbuttonlist: formVal,
    })
  }

  handlechangelistbutton(field, value, position) {
    var formVal = this.state.formbuttonlist
    formVal = formVal.set(field, value)
    if (value.length > 24) {
      formVal = formVal.set(field, value.substring(0, 24))
    }
    formVal = formVal.set('section-' + position + '-count-char-' + position, formVal.get(field).length)
    //debugger
    this.setState({
      formbuttonlist: formVal,
    })
  }


  handlechangerowbutton(field, value, position, positionchild) {
    var formVal = this.state.formbuttonrow
    let fieldtitle = 'section-' + position + '-row-' + positionchild + '-title'
    let fieldid = 'section-' + position + '-row-' + positionchild + '-id'
    let fieldcount = 'section-' + position + '-row-' + positionchild + '-title-count-char'
    let fieldcountdesc = 'section-' + position + '-row-' + positionchild + '-description-count-char'
    let fielddesc = 'section-' + position + '-row-' + positionchild + '-description'
    formVal = formVal.set(field, value)
    if (field == fieldtitle) {
      if (value.length > 24) {
        formVal = formVal.set(fieldtitle, formVal.get(fieldtitle).substring(0, 24))
        formVal = formVal.set(fieldid, formVal.get(fieldtitle).substring(0, 24))
      }
      formVal = formVal.set(fieldcount, formVal.get(fieldtitle).length)
      formVal = formVal.set(fieldid, value)
    }
    if (field == fielddesc) {
      if (value.length > 72) {
        formVal = formVal.set(fielddesc, formVal.get(fielddesc).substring(0, 72))
      }
      formVal = formVal.set(fieldcountdesc, formVal.get(fielddesc).length)
    }
    this.setState({
      formbuttonrow: formVal,
    })
    //debugger
  }

  addrow(e) {
    var target = e.target.value
    target = target.split('|')
    var section = target[0]
    var formVal = this.state.formbuttonlist
    if (this.state.counterrow < 9) {
      formVal = formVal.set(section + '-count-row-' + target[1], (formVal.get(section + '-count-row-' + target[1]) + 1))
      this.setState({
        formbuttonlist: formVal,
        counterrow: this.state.counterrow + 1,
      })
    } else return false
    //debugger
  }
  deleterow(e) {
    var fieldkey = e.target.value
    var map = new Map()
    fieldkey = fieldkey.split('|')
    var possec = fieldkey[1].split('-')
    //debugger
    var field = fieldkey[0]
    var datarow = field.split('-')
    var section = fieldkey[1]
    var indexrow = section + '-' + datarow[2] + '-'
    var formVal = this.state.formbuttonrow
    var formVallist = this.state.formbuttonlist
    var counterrowsec = parseInt(formVallist.get(section + '-count-row-' + possec[1]))
    //debugger
    if (counterrowsec == 1) {
      toast.error('Minimum submenu is one for each section', toast.POSITION.TOP_RIGHT);
      return false
    }
    formVal = formVal
      .delete(field + '-title')
      .delete(field + '-id')
      .delete(field + '-title-count-char')
      .delete(field + '-description-count-char')
      .delete(field + '-description')

    if (counterrowsec > 0) {
      for (let i = 1; i <= counterrowsec; i++) {
        let arraydata = []
        if (formVal.get(indexrow + i + '-title') != undefined) {
          arraydata.push(formVal.get(indexrow + i + '-title'))
          arraydata.push(formVal.get(indexrow + i + '-id'))
          arraydata.push(formVal.get(indexrow + i + '-title-count-char'))
          arraydata.push(formVal.get(indexrow + i + '-description-count-char'))
          arraydata.push(formVal.get(indexrow + i + '-description'))
        } else continue
        if (arraydata.length != 0)
          map.set(map.size + 1, i)

        formVal = formVal
          .set(indexrow + map.size + '-title', arraydata[0])
          .set(indexrow + map.size + '-id', arraydata[1])
          .set(indexrow + map.size + '-title-count-char', arraydata[2])
          .set(indexrow + map.size + '-description-count-char', arraydata[3])
          .set(indexrow + map.size + '-description', arraydata[4])
      }

    }

    formVal = formVal
      .delete(indexrow + (map.size + 1) + '-title')
      .delete(indexrow + (map.size + 1) + '-id')
      .delete(indexrow + (map.size + 1) + '-title-count-char')
      .delete(indexrow + (map.size + 1) + '-description-count-char')
      .delete(indexrow + (map.size + 1) + '-description')

    formVallist = formVallist.set(section + '-count-row-' + possec[1], (counterrowsec - 1))

    this.setState({
      formbuttonrow: formVal,
      formbuttonlist: formVallist,
      counterrow: this.state.counterrow - 1,
    })
  }
  deletesection(e) {
    const { countersection } = this.state
    var target = e.target.value
    target = target.split("|")
    var sectionfield = target[0]
    var formVal = this.state.formbuttonlist
    var formrow = this.state.formbuttonrow
    var rowcount = formVal.get(sectionfield + '-count-row-' + target[1])
    var datarow = sectionfield + '-row-'
    var map = new Map()
    var maprow = new Map()

    if (this.state.countersection == 1) {
      toast.error('Minimum section is one for each button', toast.POSITION.TOP_RIGHT);
      return false
    }
    formVal = formVal
      .delete(sectionfield + '-title-' + target[1])
      .delete(sectionfield + '-count-char-' + target[1])
      .delete(sectionfield + '-count-row-' + target[1])
    //debugger
    for (let i = 1; i <= rowcount; i++) {
      if (formrow.get(datarow + i + '-id') != undefined) {
        formrow = formrow
          .delete(datarow + i + '-id')
          .delete(datarow + i + '-title')
          .delete(datarow + i + '-title-count-char')
          .delete(datarow + i + '-description-count-char')
          .delete(datarow + i + '-description')
      }
    }

    if (countersection > 0) {
      for (let i = 1; i <= countersection; i++) {
        let arraydata = []
        maprow = new Map()
        if (formVal.get('section-' + i + '-title-' + i) != undefined) {
          arraydata.push(formVal.get('section-' + i + '-title-' + i))
          arraydata.push(formVal.get('section-' + i + '-count-char-' + i))
          arraydata.push(formVal.get('section-' + i + '-count-row-' + i))
          for (let j = 1; j <= formVal.get('section-' + i + '-count-row-' + i); j++) {
            let rowdata = []
            rowdata.push(formrow.get('section-' + i + '-row-' + j + '-id'))
            rowdata.push(formrow.get('section-' + i + '-row-' + j + '-title'))
            rowdata.push(formrow.get('section-' + i + '-row-' + j + '-title-count-char'))
            rowdata.push(formrow.get('section-' + i + '-row-' + j + '-description-count-char'))
            rowdata.push(formrow.get('section-' + i + '-row-' + j + '-description'))
            maprow.set(j, rowdata)
          }
        } else continue
        if (arraydata.length != 0)
          map.set(map.size + 1, i)
        //debugger
        formVal = formVal
          .set('section-' + map.size + '-title-' + map.size, arraydata[0])
          .set('section-' + map.size + '-count-char-' + map.size, arraydata[1])
          .set('section-' + map.size + '-count-row-' + map.size, arraydata[2])
        for (let k = 1; k <= formVal.get('section-' + map.size + '-count-row-' + map.size); k++) {
          //debugger
          formrow = formrow
            .delete('section-' + map.get(map.size) + '-row-' + k + '-id')
            .delete('section-' + map.get(map.size) + '-row-' + k + '-title')
            .delete('section-' + map.get(map.size) + '-row-' + k + '-title-count-char')
            .delete('section-' + map.get(map.size) + '-row-' + k + '-description-count-char')
            .delete('section-' + map.get(map.size) + '-row-' + k + '-description')
          //debugger
          formrow = formrow
            .set('section-' + map.size + '-row-' + k + '-id', maprow.get(k)[0])
            .set('section-' + map.size + '-row-' + k + '-title', maprow.get(k)[1])
            .set('section-' + map.size + '-row-' + k + '-title-count-char', maprow.get(k)[2])
            .set('section-' + map.size + '-row-' + k + '-description-count-char', maprow.get(k)[3])
            .set('section-' + map.size + '-row-' + k + '-description', maprow.get(k)[4])
          //debugger
          formVal = formVal
            .delete('section-' + (map.size + 1) + '-title-' + (map.size + 1))
            .delete('section-' + (map.size + 1) + '-count-char-' + (map.size + 1))
            .delete('section-' + (map.size + 1) + '-count-row-' + (map.size + 1))
        }
      }
    }

    this.setState({
      formbuttonrow: formrow,
      formbuttonlist: formVal,
      countersection: this.state.countersection - 1,
    })
  }
  buildsection() {
    var formVal = this.state.formbuttonlist
    const { countersection } = this.state
    for (let i = 0; i < countersection; i++) {
      var formVal = this.state.formbuttonlist
      formVal = formVal.set('section-' + (i + 1) + '-title-' + (i + 1), '')
      formVal = formVal.set('section-' + (i + 1) + '-count-char-' + (i + 1), 0)
      if (formVal.get('section-' + (i + 1) + '-count-row-' + (i + 1)) == undefined) formVal = formVal.set('section-' + (i + 1) + '-count-row-' + (i + 1), 1)
    }
    this.setState({
      formbuttonlist: formVal,
    })
    //debugger
  }

  modalbutton() {
    const { formbutton, typesbutton, listbutton, buttons, formbuttoninteractive, formbuttonlist, headerbuttonlist, formbuttonrow } = this.state
    const { hideheader, hidebuttons, hidelistbutton, hidebuttonsmedia, hidetextheader, hideinteractive } = this.state
    const { countheader, countbody, countfooter, countersection } = this.state
    let AddedButton = [];
    let ListButton = []
    let ListButtonRow = []
    var map = new Map()
    for (let i = 0; i < 3; i++) {
      AddedButton.push(
        <div className={`rows mb-2 ${hidebuttons}`}>
          <div className="cols-sm-2">
          </div>
          <div className="cols-sm-1">
            <h6>Button : </h6>
          </div>
          <div className={`cols-sm-4`}>
            <TextInputCustom
              field={formbuttoninteractive.get(i).get('id-button')}
              value={formbuttoninteractive.get(i).get('title')}
              onChange={(field, value) => this.handleChangeButton(field, value)}
              placeholder="Button title,text only no emoji allowed"
            />
          </div>
          <div className={`cols-sm-7 ${hidebuttons} `}>
          </div>
          <div className={`cols-sm-1 ${hidebuttons} `}>
            <span className="counterschar">{formbuttoninteractive.get(i).get('countchar')}/20</span>
          </div>
        </div>
      )
    }
    for (let i = 1; i <= countersection; i++) {
      for (let j = 0; j < parseInt(formbuttonlist.get('section-' + i + '-count-row-' + i)); j++) {
        //debugger
        ListButtonRow.push(
          <div>
            <div className={`rows mb-2 ${hidelistbutton}`}>
              <div className="cols-sm-3">
              </div>
              <div className="cols-sm-1">
                <h6>Sub Menu: </h6>
              </div>
              <div className={`cols-sm-3`}>
                <TextInputCustom
                  field={'section-' + i + '-row-' + (j + 1) + '-title'}
                  value={formbuttonrow.get('section-' + i + '-row-' + (j + 1) + '-title')}
                  position={i}
                  positionchild={j + 1}
                  onChange={(field, value, position, positionchild) => this.handlechangerowbutton(field, value, position, positionchild)}
                  placeholder="Title of of sub menu"
                />
              </div>
              <div className={`cols-sm-1 ${hidelistbutton} `}>

              </div>
              <div className={`cols-sm-1 ${hidelistbutton} `}>
                <button type="button"
                  className="btn btn-danger"
                  value={'section-' + i + '-row-' + (j + 1) + '|' + 'section-' + i}
                  onClick={this.deleterow}
                >
                  Delete Sub Menu
                </button>
              </div>
              <div className={`cols-sm-7 ${hidelistbutton} `}>
              </div>
              <div className={`cols-sm-1 ${hidelistbutton} `}>
                <span className="counterschar">{formbuttonrow.get('section-' + i + '-row-' + (j + 1) + '-title-count-char') == undefined
                  ? 0 : formbuttonrow.get('section-' + i + '-row-' + (j + 1) + '-title-count-char') == ""
                    ? 0 : formbuttonrow.get('section-' + i + '-row-' + (j + 1) + '-title-count-char')}/24</span>
              </div>
            </div>
            <div className={`rows mb-2 ${hidelistbutton}`}>
              <div className="cols-sm-3">
              </div>
              <div className="cols-sm-1">
                <h6>Description: </h6>
              </div>
              <div className={`cols-sm-3`}>
                <TextInputCustom
                  field={'section-' + i + '-row-' + (j + 1) + '-description'}
                  value={formbuttonrow.get('section-' + i + '-row-' + (j + 1) + '-description')}
                  position={i}
                  positionchild={j + 1}
                  onChange={(field, value, position, positionchild) => this.handlechangerowbutton(field, value, position, positionchild)}
                  placeholder="Description (optional)"
                />
              </div>
              <div className={`cols-sm-1 ${hidelistbutton} `}>
              </div>
              <div className={`cols-sm-7 ${hidelistbutton} `}>
              </div>
              <div className={`cols-sm-1 ${hidelistbutton} `}>
                <span className="counterschar">{formbuttonrow.get('section-' + i + '-row-' + (j + 1) + '-description-count-char') == undefined
                  ? 0 : formbuttonrow.get('section-' + i + '-row-' + (j + 1) + '-description-count-char') == ""
                    ? 0 : formbuttonrow.get('section-' + i + '-row-' + (j + 1) + '-description-count-char')}/72</span>
              </div>

            </div>
          </div>
        )
      }
      map.set('section-' + i, ListButtonRow)
      ListButton.push(
        <div>
          <div className={`rows mb-2 ${hidelistbutton}`}>
            <div className="cols-sm-2">
            </div>
            <div className="cols-sm-1">
              <h6>Section : </h6>
            </div>
            <div className={`cols-sm-4`}>
              <TextInputCustom
                field={'section-' + i + '-title-' + i}
                value={formbuttonlist.get('section-' + i + '-title-' + i)}
                position={i}
                onChange={(field, value, position) => this.handlechangelistbutton(field, value, position)}
                placeholder="Title of section"
              />
            </div>
            <div className="cols-sm-1">
            </div>
            <div className={`cols-sm-2`}>
              <button
                type="button"
                value={'section-' + i + "|" + i}
                className="btn btn-success"
                onClick={this.addrow}
              >
                Add Sub Menu Section
              </button>
            </div>
            <div className={`cols-sm-2`}>
              <button type="button"
                className="btn btn-danger"
                value={'section-' + i + "|" + i}
                onClick={this.deletesection}
              >
                Delete Section
              </button>
            </div>
            <div className={`cols-sm-7 ${hidelistbutton} `}>
            </div>
            <div className={`cols-sm-1 ${hidelistbutton} `}>
              <span className="counterschar">{formbuttonlist.get('section-' + i + '-count-char-' + i) == undefined ? 0 : formbuttonlist.get('section-' + i + '-count-char-' + i)}/24</span>
            </div>
          </div>
          {map.get('section-' + i)}
        </div>
      )
      ListButtonRow = []
    }

    return (
      <div className={`${hideinteractive} `}>
        <div className="rows mb-2">
          <div className="cols-sm-4">
            <h6>Select Type Button</h6>
          </div>
          <div className={`cols-sm-4 ${hideheader} `}>
            <h6>Select Header Type</h6>
          </div>
          <div className={`cols-sm-4 ${hidebuttonsmedia} `}>
            <h6>Input Media Url Header</h6>
          </div>
        </div>
        <div className="rows mb-2">
          <div className="cols-sm-4">
            <Combocustom
              field='type'
              value={formbutton.get('type')}
              options={fromJS({
                'source': typesbutton,
                'value': 'value',
                'label': 'text'
              })}
              onChange={(field, value, label) => this.handleChangeModal(field, value, label)}
              placeholder="Button Type"
            />
          </div>
          <div className={`cols-sm-4 ${hidelistbutton} `}>
            <Combocustom
              field='header-type'
              value={formbutton.get('header-type')}
              options={fromJS({
                'source': listbutton,
                'value': 'value',
                'label': 'text'
              })}
              onChange={(field, value, label) => this.handleChangeModal(field, value, label)}
              placeholder="Header Type"
            />
          </div>
          <div className={`cols-sm-4 ${hidebuttons} `}>
            <Combocustom
              field='header-type'
              value={formbutton.get('header-type')}
              options={fromJS({
                'source': buttons,
                'value': 'value',
                'label': 'text'
              })}
              onChange={(field, value, label) => this.handleChangeModal(field, value, label)}
              placeholder="Header Type"
            />
          </div>
          <div className={`cols-sm-4 ${hidebuttonsmedia} `}>
            <TextInputCustom
              field='url-header'
              value={formbutton.get('url-header')}
              onChange={(field, value) => this.handleChangeModal(field, value)}
              placeholder="URL Media"
            />
          </div>
        </div>
        <div className={`rows mb-2 ${hidetextheader}`}>
          <div className={`cols-sm-12`}>
            <h6>Header Message</h6>
          </div>
          <div className={`cols-sm-12 ${hidetextheader} `}>
            <TextInputCustom
              field='header'
              value={formbutton.get('header')}
              onChange={(field, value) => this.handleChangeModal(field, value)}
              placeholder="Header Text"
            />
          </div>
        </div>
        <div className={`rows mb-2 no-margin-bottom ${hidetextheader}`}>
          <div className={`cols-sm-11 ${hidetextheader} `}>
          </div>
          <div className={`cols-sm-1 ${hidetextheader} `}>
            <span className="counterschar">{countheader}/60</span>
          </div>
        </div>
        <div className={`rows mb-2`}>
          <div className={`cols-sm-12`}>
            <h6>Body Message</h6>
          </div>
          <div className={`cols-sm-12  `}>
            <TextInputCustom
              textarea
              rows={8}
              field='body'
              value={formbutton.get('body')}
              onChange={(field, value) => this.handleChangeModal(field, value)}
              placeholder="Body Text"
            />
          </div>
          <div className={`cols-sm-12`}>
            <div className="countersbody"><span className="counters">characters count : {countbody}/1024</span></div>
          </div>
        </div>
        <div className={`rows mb-2 `}>
          <div className={`cols-sm-12`}>
            <h6>Footer Message</h6>
          </div>
          <div className={`cols-sm-12`}>
            <TextInputCustom
              field='footer'
              value={formbutton.get('footer')}
              onChange={(field, value) => this.handleChangeModal(field, value)}
              placeholder="Footer Text"
            />
          </div>
        </div>
        <div className={`rows mb-2 no-margin-bottom`}>
          <div className={`cols-sm-11`}>
          </div>
          <div className={`cols-sm-1 `}>
            <span className="counterschar">{countfooter}/60</span>
          </div>
        </div>
        {AddedButton}
        <div className={`rows mb-2 ${hidelistbutton}`}>
          <div className="cols-sm-2">
            <h6>Menu Button Title: </h6>
          </div>
          <div className={`cols-sm-4`}>
            <TextInputCustom
              field='menu-title'
              value={headerbuttonlist.get('menu-title')}
              onChange={(field, value) => this.handlechangeheader(field, value)}
              placeholder="Title for your menu button"
            />
          </div>
          <div className="cols-sm-1">
          </div>
          <div className="cols-sm-1">
            <button type="button"
              className="btn btn-success"
              onClick={() => {
                if (this.state.countersection < 2) {
                  this.setState({ countersection: this.state.countersection += 1 })
                  this.buildsection()
                } else {
                  return false
                }

              }}>
              Add Section
            </button>
          </div>
          <div className="cols-sm-3">
          </div>
          <div className={`cols-sm-6 ${hidelistbutton} `}>
          </div>
          <div className={`cols-sm-1 ${hidelistbutton} `}>
            <span className="counterschar">{headerbuttonlist.get('count-char')}/20</span>
          </div>

        </div>
        {ListButton}
      </div>
    )
  }
  componentWillMount() {
    const { formbuttoninteractive, headerbuttonlist } = this.state
    var formValinter = formbuttoninteractive;
    var formbuttonlist = this.state.formbuttonlist
    var formbuttonrow = this.state.formbuttonrow
    var formheaderbutlist = headerbuttonlist
    var counterrow = 1
    var countersection = 1

    if (this.props.item != null || this.props.item !== undefined) {
      if ((this.props.actionType === IsView || this.props.actionType === IsEdit) && !this.state.loadded) {
        //debugger
        var category = ''
        if (this.props.item.get('replycategory') == "non interactive"
          || this.props.item.get('replycategory') == undefined) {
          category = 'non Interactive'
          this.setState({ hideinteractive: 'hide', hidenoninter: '' })
        } else {

          category = 'interactive'
          var jsonreq = JSON.parse(this.props.item.get('interactive'))
          var typebutton = jsonreq.type
          var urlheader = ''
          //debugger
          if (jsonreq.header.type != 'text') {
            if (jsonreq.header.type == 'image') urlheader = jsonreq.header.image.link
            if (jsonreq.header.type == 'video') urlheader = jsonreq.header.video.link
            if (jsonreq.header.type == 'document') urlheader = jsonreq.header.document.link

            this.setState({ hidebuttonsmedia: '', hidetextheader: 'hide' })
          } else {
            urlheader = ''
            this.setState({ hidebuttonsmedia: 'hide', hidetextheader: '' })
          }
          if (typebutton == 'button') {
            this.setState({ hidebuttons: '' })
            if (jsonreq.action.buttons.length != 0) {
              for (let k = 0; k < jsonreq.action.buttons.length; k++) {
                formValinter = formValinter
                  .set(k, formValinter.get(k)
                    .set('title', jsonreq.action.buttons[k].reply.title)
                    .set('id', jsonreq.action.buttons[k].reply.title)
                    .set('countchar', jsonreq.action.buttons[k].reply.title.length))
              }
            }
          } else if (typebutton == 'list') {
            formheaderbutlist = formheaderbutlist
              .set('menu-title', jsonreq.action.button)
              .set('count-char', jsonreq.action.button.length)
            countersection = jsonreq.action.sections.length
            for (let h = 0; h < jsonreq.action.sections.length; h++) {
              for (let h = 0; h < jsonreq.action.sections.length; h++) {
                formbuttonlist = formbuttonlist
                  .set('section-' + (h + 1) + '-title-' + (h + 1), jsonreq.action.sections[h].title)
                  .set('section-' + (h + 1) + '-count-char-' + (h + 1), jsonreq.action.sections[h].title.length)
                  .set('section-' + (h + 1) + '-count-row-' + (h + 1), jsonreq.action.sections[h].rows.length)
                for (let j = 0; j < jsonreq.action.sections[h].rows.length; j++) {

                  //debugger
                  formbuttonrow = formbuttonrow
                    .set('section-' + (h + 1) + '-row-' + (j + 1) + '-title', jsonreq.action.sections[h].rows[j].title)
                    .set('section-' + (h + 1) + '-row-' + (j + 1) + '-id', jsonreq.action.sections[h].rows[j].title)
                    .set('section-' + (h + 1) + '-row-' + (j + 1) + '-title-count-char', jsonreq.action.sections[h].rows[j].title.length)
                  if (jsonreq.action.sections[h].rows[j].description != undefined) {
                    formbuttonrow = formbuttonrow
                      .set('section-' + (h + 1) + '-row-' + (j + 1) + '-description-count-char', jsonreq.action.sections[h].rows[j].description.length)
                      .set('section-' + (h + 1) + '-row-' + (j + 1) + '-description', jsonreq.action.sections[h].rows[j].description)
                  } else continue
                  counterrow += 1
                }
              }
              this.setState({ hidelistbutton: '' })
            }
          }
          //debugger
          this.setState({
            hideinteractive: '', hidenoninter: 'hide',
            countheader: (this.props.item.get('header')).length,
            countbody: (this.props.item.get('body')).length,
            countfooter: (this.props.item.get('footer')).length,
            formbutton: fromJS({
              'type': typebutton,
              'header-type': jsonreq.header.type,
              'url-header': urlheader,
              'header': this.props.item.get('header'),
              'body': this.props.item.get('body'),
              'footer': this.props.item.get('footer'),
            }),
            formbuttoninteractive: formValinter,
            formbuttonlist: formbuttonlist,
            formbuttonrow: formbuttonrow,
            headerbuttonlist: formheaderbutlist,
            counterrow: counterrow,
            countersection: countersection
          })
        }

        this.setState({

          form: fromJS({
            'reply-id': this.props.item.get('reply-id'),
            'group-id': this.props.item.get('group-id'),
            'reply-type': this.props.item.get('reply-type'),
            'caption': this.props.item.get('caption'),
            'url': this.props.item.get('url'),
            'type-category': category
          }),
          loadded: true,
          disabled: (this.props.actionType === IsView),
        })
        if (this.props.item.get('reply-type') == "sticker") {
          this.setState({
            showCaptionField: 'hide',
            showUrlField: true
          })
        } else if (this.props.item.get('reply-type') == "text") {
          this.setState({
            showUrlField: false
          })
        }
      }
    }
  }



  render() {
    const { form, errors, types, showCaptionField, typescategory } = this.state;
    const { hidenoninter } = this.state;


    return (
      <div>
        <div className="card no-margin-bottom">
          <div className="body">

            {this.renderGroupId(form, errors)}
            <div className="row no-margin-bottom">
              <span className="col-sm-2">Reply Category *</span>
              <div className="col-sm-10">
                <Combocustom
                  field='type-category'
                  value={form.get('type-category')}
                  options={fromJS({
                    'source': typescategory,
                    'value': 'value',
                    'label': 'text'
                  })}
                  onChange={(field, value, label) => this.handleChange(field, value, label)}
                  placeholder="Reply Category"
                  disabled={this.state.disabled}
                />
              </div>
            </div>
            <div className={`${hidenoninter} `}>
              <div className="row no-margin-bottom">
                <span className="col-sm-2">Type *</span>
                <div className="col-sm-10">
                  <Combocustom
                    field='reply-type'
                    value={form.get('reply-type')}
                    options={fromJS({
                      'source': types,
                      'value': 'value',
                      'label': 'text'
                    })}
                    onChange={(field, value, label) => this.handleChange(field, value, label)}
                    placeholder="Reply-Type"
                    disabled={this.state.disabled}
                    hasError={errors.has('reply-type')}
                  />
                </div>
              </div>
              {this.renderUrlField(form, errors)}

              <div className={`row no-margin-bottom ${showCaptionField}`}>
                <span className="col-sm-2">Caption *</span>
                <div className="col-sm-10">
                  <TextInputCustom className='captions'
                    textarea
                    row={3}
                    field={'caption'}
                    value={form.get('caption')}
                    onChange={(field, value) => this.handleChange(field, value)}
                    placeholder="caption"
                    hasError={errors.has('caption')}
                  />
                </div>
              </div>
            </div>
            {this.modalbutton()}
            <div className="row no-margin-bottom">
              <span className="col-sm-2"></span>
              <div className="col-sm-10">
                <button type="button"
                  className="btn btn-wide btn-danger"
                  value="Cancel"
                  onClick={this.handleCancel}>
                  Cancel
                </button>
                <button type="button"
                  className="btn btn-wide btn-success"
                  onClick={this.handleSubmit}>
                  Submit
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>

    );
  }
  renderUrlField(form, errors) {
    if (this.state.showUrlField) {
      return (
        <div className="row no-margin-bottom">
          <span className="col-sm-2">Url *</span>
          <div className="col-sm-10">
            <TextInputCustom
              field={'url'}
              value={form.get('url')}
              onChange={(field, value) => this.handleChange(field, value)}
              placeholder="url"
              hasError={errors.has('url')}
            />
          </div>
        </div>
      )
    }
  }


  renderGroupId(form, errors) {
    if (this.props.actionType == IsCreate) {
      return <div className="row no-margin-bottom">
        <span className="col-sm-2">Group *</span>
        <div className="col-sm-10">
          <Combocustom
            field='group-id'
            value={form.get('group-id')}
            options={fromJS({
              'source': this.props.keygroups,
              'value': 'group-id',
              'label': 'group-name'
            })}
            onChange={(field, value, label) => this.handleChange(field, value, label)}
            placeholder="Group"
            disabled={this.state.disabled}
            hasError={errors.has('group-id')}
          />
        </div>
      </div>
    }
  }
}


export default connect(
  (state) => {
    return {
      keygroups: state.user.keygroupall,
    }
  },
  dispatch => bindActionCreators({
    actionAdd: ActionAdd,
    actionEdit: ActionEdit,
    actionGetKeyGroup: ActionGetKeyGroup,
  }, dispatch),
)(Form);